import { render, staticRenderFns } from "./ObjectData.vue?vue&type=template&id=3067abcb&scoped=true&"
import script from "./ObjectData.vue?vue&type=script&lang=js&"
export * from "./ObjectData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3067abcb",
  null
  
)

export default component.exports